import Cookies from 'js-cookie';
import { getMessageData } from '@/api/message.js'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    noticeList:[],
    updateMapData:0,
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_NOTICELIST: (state, list) => {
      state.noticeList = list
    },
    SET_UPDATEMAP: (state, bool) => {
      state.updateMapData = bool
    },
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    getNoticeList({ commit }, data) {
      return new Promise((resolve,reject)=>{
        getMessageData(data).then((res)=>{
          commit('SET_NOTICELIST', res.data.list)
          resolve()
        })
      })
      
    },
    SetMapDataStatus({ commit }, bool) {
      commit('SET_UPDATEMAP', bool)
    },
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js